import { UserAccount as UserAccountComponent } from 'components/UserAccount'
import React from 'react'
import { Container, Row } from 'react-bootstrap'

const UserAccount = () => {
    return (
        <>
            <Container>
                <Row>
                    <UserAccountComponent />
                </Row>
            </Container>
        </>
    )
}

export default UserAccount
